/**
 * Site APIs
 * APIs for content management
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface Field { 
    archived?: boolean;
    createdAt?: string;
    id?: string;
    importObjectKey?: string;
    importSessionKey?: string;
    locked?: boolean;
    name?: string;
    published?: boolean;
    readOnly?: boolean;
    required?: boolean;
    sortOrder?: number;
    /**
     * string, text
     */
    type?: string;
    updatedAt?: string;
    version?: number;
}
